<template>
  <div class="ds-progress-gauge" role="img" :aria-label="resolvedAriaLabel">
    <svg class="ds-progress-gauge__svg" viewBox="0 0 200 120" aria-hidden="true">
      <path
        class="ds-progress-gauge__track"
        d="M 20 96 A 80 80 0 0 1 180 96"
        pathLength="100"
        fill="none"
        :stroke="trackColor"
      />
      <path
        class="ds-progress-gauge__value"
        d="M 20 96 A 80 80 0 0 1 180 96"
        pathLength="100"
        fill="none"
        :stroke="progressColor"
        :stroke-dasharray="`${normalizedPercentage} 100`"
      />
    </svg>

    <span class="ds-progress-gauge__percentage" :style="{ color: textColor }">
      {{ displayPercentage }}%
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  percentage?: number
  progressColor?: string
  trackColor?: string
  textColor?: string
  ariaLabel?: string
}>(), {
  percentage: 84,
  progressColor: 'var(--ds-orange-200)',
  trackColor: 'var(--ds-orange-50)',
  textColor: 'var(--ds-purple-900)',
  ariaLabel: ''
})

const normalizedPercentage = computed(() => Math.min(Math.max(props.percentage, 0), 100))
const displayPercentage = computed(() => Math.round(normalizedPercentage.value))
const resolvedAriaLabel = computed(() => props.ariaLabel || `${displayPercentage.value}% de avance`)
</script>

<style scoped>
.ds-progress-gauge {
  --ds-progress-gauge-stroke-width: 14;
  --ds-progress-gauge-percentage-size: 28px;
  --ds-progress-gauge-percentage-bottom: 8px;

  position: relative;
  width: 298px;
  max-width: 100%;
  height: 102px;
}

.ds-progress-gauge__svg {
  display: block;
  width: 100%;
  height: 100%;
}

.ds-progress-gauge__track,
.ds-progress-gauge__value {
  stroke-width: var(--ds-progress-gauge-stroke-width);
  stroke-linecap: round;
}

.ds-progress-gauge__percentage {
  position: absolute;
  left: 50%;
  bottom: var(--ds-progress-gauge-percentage-bottom);
  transform: translateX(-50%);
  font-family: "Inter", sans-serif;
  font-size: var(--ds-progress-gauge-percentage-size);
  font-weight: 700;
  line-height: 1;
}
</style>
